<template>
  <el-dialog :visible.sync="visible" :before-close="handleClose" v-bind="store.dialog.propsData" :width="width">
    <component v-if="store.dialog.component" ref="component" v-bind:is="store.dialog.component" v-bind="store.dialog.propsData" title=""> </component>
  </el-dialog>
</template>

<script>
import store from './store';
export default {
  name: 'AppMainDialog',
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      visible: false,
      store,
    };
  },
  computed: {
    width() {
      return store.dialog?.propsData?.width || '500px';
    },
  },
  watch: {},
  directives: {},
  filters: {},
  created() {},
  mounted() {
    // 保证子组件可以使用 $closeDialog
    setTimeout(() => {
      this.$refs.component.$closeDialog = (flg, data) => {
        this.$closeDialog(flg, data);
      };
    });
  },
  beforeDestroy() {},
  methods: {
    handleClose() {
      this.$closeDialog(false);
    },
  },
};
</script>

<style scoped lang="scss"></style>
